import { createReferenceListModule } from "./create-reference-list-module.js";
import { referenceListIdToCamelCase } from "./reference-list-entries.js";

export const TRAINER_ABSENCE_REASON_IDS = Object.freeze(["vacation", "sick", "holiday"]);

export const BILLING_FREQUENCY_IDS = Object.freeze(["after_session", "monthly", "quarterly"]);

export const BILLING_PAYMENT_TIMING_IDS = Object.freeze(["advance", "arrears"]);

export const TRAINER_PAYOUT_FREQUENCY_IDS = Object.freeze([
  "weekly",
  "monthly",
  "quarterly",
  "seasonal",
  "ad_hoc",
]);

export const TRAINER_PAYOUT_METHOD_IDS = Object.freeze([
  "club_transfer",
  "trainer_direct",
  "cash",
  "paypal",
  "other",
]);

export const trainerAbsenceReasonsModule = createReferenceListModule({
  listKey: "trainerAbsenceReasons",
  builtinIds: TRAINER_ABSENCE_REASON_IDS,
  labelKeyForId: (id) => `trainerstunden.trainer.absence.${id}`,
  customIdPrefix: "trainer_absence_custom_",
  customDbStoresId: true,
});

export const billingFrequenciesModule = createReferenceListModule({
  listKey: "billingFrequencies",
  builtinIds: BILLING_FREQUENCY_IDS,
  labelKeyForId: (id) =>
    `trainerstunden.trainer.billingFrequency.${referenceListIdToCamelCase(id)}`,
  customIdPrefix: "billing_frequency_custom_",
  customDbStoresId: true,
});

export const billingPaymentTimingsModule = createReferenceListModule({
  listKey: "billingPaymentTimings",
  builtinIds: BILLING_PAYMENT_TIMING_IDS,
  labelKeyForId: (id) => `trainerstunden.trainer.billingTiming.${id}`,
  customIdPrefix: "billing_timing_custom_",
  customDbStoresId: true,
});

export const trainerPayoutFrequenciesModule = createReferenceListModule({
  listKey: "trainerPayoutFrequencies",
  builtinIds: TRAINER_PAYOUT_FREQUENCY_IDS,
  labelKeyForId: (id) =>
    `trainerstunden.trainer.payoutFrequency.${referenceListIdToCamelCase(id)}`,
  customIdPrefix: "trainer_payout_freq_custom_",
  customDbStoresId: true,
});

export const trainerPayoutMethodsModule = createReferenceListModule({
  listKey: "trainerPayoutMethods",
  builtinIds: TRAINER_PAYOUT_METHOD_IDS,
  labelKeyForId: (id) =>
    `trainerstunden.trainer.payoutMethod.${referenceListIdToCamelCase(id)}`,
  customIdPrefix: "trainer_payout_method_custom_",
  customDbStoresId: true,
});

function exportModule(mod) {
  return {
    defaults: mod.defaults,
    resolveEntries: mod.resolveEntries,
    resolveEntriesForAdmin: mod.resolveEntriesForAdmin,
    resolveLabel: mod.resolveLabel,
    resolveLabelById: mod.resolveLabelById,
    isAllowedId: mod.isAllowedId,
  };
}

export const {
  defaults: defaultTrainerAbsenceReasonEntries,
  resolveEntries: resolveTrainerAbsenceReasonEntries,
  resolveEntriesForAdmin: resolveTrainerAbsenceReasonEntriesForAdmin,
  resolveLabel: resolveTrainerAbsenceReasonLabel,
  resolveLabelById: resolveTrainerAbsenceReasonLabelById,
} = exportModule(trainerAbsenceReasonsModule);

export const {
  defaults: defaultBillingFrequencyEntries,
  resolveEntries: resolveBillingFrequencyEntries,
  resolveEntriesForAdmin: resolveBillingFrequencyEntriesForAdmin,
  resolveLabel: resolveBillingFrequencyLabel,
  resolveLabelById: resolveBillingFrequencyLabelById,
} = exportModule(billingFrequenciesModule);

export const {
  defaults: defaultBillingPaymentTimingEntries,
  resolveEntries: resolveBillingPaymentTimingEntries,
  resolveEntriesForAdmin: resolveBillingPaymentTimingEntriesForAdmin,
  resolveLabel: resolveBillingPaymentTimingLabel,
  resolveLabelById: resolveBillingPaymentTimingLabelById,
} = exportModule(billingPaymentTimingsModule);

export const {
  defaults: defaultTrainerPayoutFrequencyEntries,
  resolveEntries: resolveTrainerPayoutFrequencyEntries,
  resolveEntriesForAdmin: resolveTrainerPayoutFrequencyEntriesForAdmin,
  resolveLabel: resolveTrainerPayoutFrequencyLabel,
  resolveLabelById: resolveTrainerPayoutFrequencyLabelById,
} = exportModule(trainerPayoutFrequenciesModule);

export const {
  defaults: defaultTrainerPayoutMethodEntries,
  resolveEntries: resolveTrainerPayoutMethodEntries,
  resolveEntriesForAdmin: resolveTrainerPayoutMethodEntriesForAdmin,
  resolveLabel: resolveTrainerPayoutMethodLabel,
  resolveLabelById: resolveTrainerPayoutMethodLabelById,
} = exportModule(trainerPayoutMethodsModule);

/**
 * @param {unknown} lists
 * @param {(key: string) => string} t
 * @param {{ includeEmpty?: boolean, emptyLabelKey?: string }} [options]
 */
export function buildReferenceListSelectOptions(resolveEntries, resolveLabel, lists, t, options = {}) {
  const rows = resolveEntries(lists).map((entry) => ({
    value: entry.id,
    label: resolveLabel(entry, t),
  }));
  if (options.includeEmpty) {
    return [{ value: "", label: t(options.emptyLabelKey || "trainerstunden.chooseOptional") }, ...rows];
  }
  return rows;
}
